module.exports = __webpack_public_path__ + "img/2024-11-15c_2.7504f0ca.jpg";